<template>
  <component
    :is="tag"
    :class="computedClasses"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import type { HeadingComponent } from './types'

const props = withDefaults(defineProps<{
  tag?: HeadingComponent
  level: 1 | 2 | 3 | 4 | 5 | 6 | 7
}>(), {
  tag: 'h1',
})

const computedClasses = computed(() => {
  return [
    'flex items-center gap-2 font-semibold',
    {
      'text-2xl/10 sm:text-3xl/10 md:text-4xl/10': props.level === 1,
      'text-xl/8 sm:text-2xl/8 md:text-3xl/8': props.level === 2,
      'text-lg/7 sm:text-xl/7 md:text-2xl/7': props.level === 3,
      'text-lg/7 md:text-xl/7': props.level === 4,
      'text-base/6 md:text-lg/6': props.level === 5,
      'text-base/6': props.level === 6,
      'text-sm/6': props.level === 7,
    },
  ]
})
</script>
